import {defineMessages} from 'react-intl';

export default defineMessages({
  selectModule: {
    defaultMessage: 'Select module',
    id: 'LandingPage.SectionManager.Curriculum.CurriculumMobile.SelectModule',
  },
});
